import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, Card, Button, Table, Tag, Space, Typography, message } from 'antd';
import * as Icon from 'react-feather';
import { Link } from 'react-router-dom';
import {
  userReportActionStart,
  userReportActionError,
  getAllUserReportsAction,
} from '../../core/data/redux/modules/userReport/actions';
import { getAllUserReports } from '../../services/adminServices/userReport';

const { Title } = Typography;

const ListUserReports = () => {
  const dispatch = useDispatch();
  const { reports, loading, error } = useSelector((state: any) => state.userReport || { reports: [], loading: false, error: null });

  useEffect(() => {
    fetchReports();
    // eslint-disable-next-line
  }, []);

  const fetchReports = async () => {
    dispatch(userReportActionStart());
    try {
      const res = await getAllUserReports();
      if (res.error) throw new Error(res.message || 'Error fetching reports');
      dispatch(getAllUserReportsAction(res.data));
    } catch (err: any) {
      dispatch(userReportActionError(err.message));
      message.error(err.message);
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Reported User',
      dataIndex: 'reported_user',
      key: 'reported_user',
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'open' ? 'orange' : 'green'}>{status}</Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Space>
          <Link to={`/admin/user-report/user-report-detail/${record.id}`}>
            <Button icon={<Icon.Eye size={16} />} size="small" />
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/user-report/list-user-reports">User Reports</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Table
            columns={columns}
            dataSource={reports}
            loading={loading}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </div>
    </div>
  );
};

export default ListUserReports; 